import React from 'react'
import './Footer.css'

import Wave from '../../img/wave.png'

import Github from '../../img/github.png';
import LinkedIn from '../../img/linkedin.png';
import Instagram from '../../img/instagram.png';

const Footer = () => {
    return(
        <div className="footer">
            <img src={Wave} alt="" style={{width : '100%'}} />
            <div className="f-content">
                <a href="mailto:divakarkumarchy2001@gmail.com"><span>divakarkumarchy2001@gmail.com</span></a>
                <div className="f-icons">
                    <a href="https://github.com/choudhary2001/" target="_blank"> <img src={Github} alt="" /></a>
                    <a href="https://linkdin.com/divakar-kumar-choudhary"  target="_blank"><img src={LinkedIn} alt="" /></a>
                    <a href="https://instagram.com/divakarkumar.choudhary"  target="_blank"> <img src={Instagram} alt="" /> </a>
                </div>
            </div>
        </div>
    )
}

export default Footer